module.exports = __webpack_public_path__ + "img/popeye.89be7c53.jpg";